import fea1 from '../assets/images/illustrator/1.svg'
import fea2 from '../assets/images/illustrator/2.svg'
import fea3 from '../assets/images/illustrator/3.svg'

export const featureData = [
    {
        image:fea1,
        title:'Responsive Design',
        desc:'It seems that only fragments of the original text remain in the fragments Lorem Ipsum texts used today.'
    },
    {
        image:fea2,
        title:'Fresh Layouts',
        desc:'It seems that only fragments of the original text remain in the fragments Lorem Ipsum texts used today.'
    },
    {
        image:fea3,
        title:'Modern Workflow',
        desc:'It seems that only fragments of the original text remain in the fragments Lorem Ipsum texts used today.'
    },
]